import { render, staticRenderFns } from "./AccountLink.vue?vue&type=template&id=024d6291&scoped=true&"
import script from "./AccountLink.vue?vue&type=script&lang=js&"
export * from "./AccountLink.vue?vue&type=script&lang=js&"
import style0 from "./AccountLink.vue?vue&type=style&index=0&id=024d6291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d6291",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024d6291')) {
      api.createRecord('024d6291', component.options)
    } else {
      api.reload('024d6291', component.options)
    }
    module.hot.accept("./AccountLink.vue?vue&type=template&id=024d6291&scoped=true&", function () {
      api.rerender('024d6291', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/AccountLink.vue"
export default component.exports